enum NotesSortOption {
  Newest = 'newest',
  Oldest = 'oldest',
}

export default NotesSortOption;
